<template>
	<el-drawer
		:modelValue="open"
		@update:modelValue="$emit('update:open', $event)"
		:before-close="handleClose"
		direction="btt"
		:modal-class="'TableSortDrawer'"
		:show-close="true"
		:title="'Sortieren'"
		size="100%"
	>
		<template #default>
			<span>Sortieren nach </span>

			<el-radio-group v-model="stringifiedSorting" @change="handleClose">
				<el-radio v-for="o in sortOptions" :key="o.label" :value="JSON.stringify(o.value)" :border="true">{{ o.label }}</el-radio>
			</el-radio-group>
		</template>
	</el-drawer>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import { TableSort } from '../types/types';

export default defineComponent({
	name: 'TableSortDrawer',
	data() {
		return {
			searchTerm: '',
			sorting: this.currentSort || ({ prop: 'voteEndDate', order: 'ascending' } as TableSort),
			sortOptions: [
				{ value: { prop: 'state', order: 'ascending' }, label: 'Status (offen-entschieden)' },
				{ value: { prop: 'state', order: 'descending' }, label: 'Status (entschieden-offen)' },
				{ value: { prop: 'title', order: 'ascending' }, label: 'Titel (A-Z)' },
				{ value: { prop: 'title', order: 'descending' }, label: 'Titel (Z-A)' },
				{ value: { prop: 'voteEndDate', order: 'ascending' }, label: 'WR-Entscheidung bis (1-9)' },
				{ value: { prop: 'voteEndDate', order: 'descending' }, label: 'WR-Entscheidung bis (9-1)' },
			],
		};
	},
	emits: ['update:open', 'setSort'],
	props: {
		open: {
			type: Boolean,
			required: true,
		},
		currentSort: {
			type: Object as PropType<TableSort>,
			default: null,
		},
	},
	computed: {
		stringifiedSorting: {
			get() {
				return JSON.stringify(this.sorting);
			},
			set(value) {
				this.sorting = JSON.parse(value);
			},
		},
	},
	methods: {
		handleClose() {
			this.$emit('update:open', false);
			this.$emit('setSort', this.sorting);
		},
	},
	mounted() {
		if (this.currentSort) {
			this.sorting = this.currentSort;
		}
	},
});
</script>

<style lang="scss">
.TableSortDrawer {
	.el-drawer__header {
		margin-bottom: 0;
		padding: 1rem 2rem;

		.el-drawer__close-btn {
			padding: 0;
			.el-icon.el-drawer__close {
				margin: 0;
			}
		}
	}

	.el-drawer__body {
		background-color: var(--el-color-lightgrey-1);
		padding: 2rem;

		.el-radio-group {
			margin-top: 2rem;

			.el-radio.is-bordered {
				width: 100%;
				height: 3rem;

				.el-radio__input.is-checked {
					display: none;
				}

				.el-radio__label {
					width: 100%;
					text-align: center;
					font-size: 1rem;
				}
			}
		}
	}
}
</style>
